import VueDOMPurifyHTML from 'vue-dompurify-html'
import Vue3Lottie from 'vue3-lottie'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { defineAsyncComponent } from '#imports'
import { defineNuxtPlugin } from '#app'
import disableTabindex from '~/directives/disable-tabindex'
import FileDownloadBlock from '~/components/utils/FileDownloadBlock.vue'
import TipBlock from '~/components/TipBlock.vue'
import GeoGebraApplet from '~/components/geogebra/GeoGebraApplet.vue'
import EmbedFormWriter from '~/components/formwriter/EmbedFormWriter.vue'
import FlytTask from '~/components/flyt/FlytTask.vue'
import SourceBox from '~/components/embeds/SourceBox.vue'
import EmbedVideo from '~/components/embeds/EmbedVideo.vue'
import EmbedVgsImage from '~/components/embeds/EmbedVgsImage.vue'
import EmbedImage from '~/components/embeds/EmbedImage.vue'
import EmbedFlashcardDeck from '~/components/embeds/EmbedFlashcardDeck.vue'
import EmbedFlashcard from '~/components/embeds/EmbedFlashcard.vue'
import EmbedAudio from '~/components/embeds/EmbedAudio.vue'
import ColorBox from '~/components/embeds/ColorBox.vue'
import CodeEditor from '~/components/embeds/CodeEditor.vue'
import Glossary from '~/components/customTags/Glossary.vue'
import EmbedConversation from '~/components/conversation/EmbedConversation.vue'
import ConversationItem from '~/components/conversation/ConversationItem.vue'
import EmbedBot from '~/components/chat/EmbedBot.vue'
import EmbedImageCollection from '~/components/article/EmbedImageCollection.vue'

export default defineNuxtPlugin(({ vueApp: app }) => {
  app.directive('disable-tabindex', disableTabindex)
  app.directive<HTMLElement, { delay?: number } | undefined>('focus', {
    mounted: (el, binding) => {
      if (binding.value?.delay) {
        return setTimeout(() => {
          el.focus()
        }, binding.value.delay)
      }

      el.focus()
    }
  })

  app.use(VueDOMPurifyHTML, {
    default: {
      USE_PROFILES: { html: true, mathMl: true },
    },
  })

  app.use(Vue3Lottie, {
    name: 'LottieAnimation',
  })

  app.component('FlytTask', FlytTask)
  app.component('EmbedVideo', EmbedVideo)
  app.component('EmbedAudio', EmbedAudio)
  app.component('EmbedImage', EmbedImage)
  app.component('EmbedFlashcardDeck', EmbedFlashcardDeck)
  app.component('EmbedFlashcard', EmbedFlashcard)
  app.component('EmbedConversation', EmbedConversation)
  app.component('EmbedImageCollection', EmbedImageCollection)
  app.component('TipBlock', TipBlock)
  app.component('FileDownloadBlock', FileDownloadBlock)
  app.component('Glossary', Glossary)
  app.component('EmbedBot', EmbedBot)
  app.component('GeoGebraApplet', GeoGebraApplet)
  app.component('ColorBox', ColorBox)
  app.component('SourceBox', SourceBox)
  app.component('Model3d', defineAsyncComponent(() => import('~/components/model3d/EmbedModel.vue')))
  app.component('FormWriter', EmbedFormWriter)
  app.component('font-awesome-icon', FontAwesomeIcon)
  app.component('rich-text-image', EmbedVgsImage)
  app.component('CodeEditor', CodeEditor)
  app.component('CodeBlock', defineAsyncComponent(() => import('~/components/customTags/CodeBlock.vue')))
  app.component('ConversationItem', ConversationItem)
})
